// SINGLE ENTRY AGGREGATED BUNDLE (IIFE OUTPUT)
// -----------------------------------------------------------------------------
// VENDOR FILES (converted from Gulp //=include to ES module imports for Vite)
// -----------------------------------------------------------------------------
import '../../source/vendor/bootstrap-5.3.8/dist/js/bootstrap.bundle.min.js';

// CUSTOM CODE
// -----------------------------------------------------------------------------

//Carousel pattern (splide) custom js for page numbering
document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.getElementsByClassName('carousel');
    for (let i = 0; i < carousels.length; i++) {
        const parentCarouselPattern = document.getElementsByClassName('carousel')[i];

        //create and place the html span that will contain the numbers indicator
        let carousel_numbers_element = document.createElement('span');
        carousel_numbers_element.className = 'splide-numbers';
        carousel_numbers_element.textContent = '';
        // Ensure the previous arrow exists before calling `after`
        const prevArrow1 = parentCarouselPattern.getElementsByClassName('splide__arrow--prev')[0];
        if (prevArrow1) {
            prevArrow1.after(carousel_numbers_element);
        } else {
            console.warn('Previous arrow not found. Unable to append carousel_numbers_element.');
        }

        //create the pause/play button that exists in some variations of the slider. Unlike above, do not render it yet.
        let carousel_pause_play_element = document.createElement('button');
        let carousel_pause_inner_span = document.createElement('span');
        let PausePlayVideoOnButtonPressInitialize = () => {};
        let updateVideoAndButtonOnSlideChange = () => {};
        carousel_pause_play_element.className = 'splide-pausePlayBtn';
        carousel_pause_play_element.classList.add('pause');
        carousel_pause_inner_span.textContent = 'pause'; //pause will be the default text, visually hidden
        carousel_pause_inner_span.className = 'visually-hidden';
        carousel_pause_play_element.appendChild(carousel_pause_inner_span);

        //get the value content of the current slide you're on that Splide already provides by default -- e.g. "2 of 6"
        // Ensure the active slide exists before calling `getAttribute`
        let splide_aria_number_data = '';
        const activeSlide = parentCarouselPattern.querySelectorAll('.splide__slide.is-active')[0];
        if (activeSlide) {
            splide_aria_number_data = activeSlide.getAttribute('aria-label');
            splideNumberStringAlteration(splide_aria_number_data);
            carousel_numbers_element.textContent = splide_aria_number_data;
        } else {
            console.warn('Active slide not found. Unable to retrieve aria-label.');
        }

        // Detect when '.is-active' moves from one Splide slide to another, via MutationObserver, which means the specific input method triggering its movemenet does not matter.
        // https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
        // Select the node that will be observed for mutations
        const splideSlidesContainer = document.querySelectorAll('.splide__list')[i];
        const targetNode = splideSlidesContainer;
        let isThrottled = false;

        // Options for the observer (which mutations to observe)
        const config = { attributes: true };

        // Callback function to execute when mutations are observed
        const callback = (mutationList) => {
            for (const mutation of mutationList) {
                if (mutation.type === 'attributes') {
                    if (isThrottled) {
                        return; //return if isThrottled is true so this doesn't risk running hundreds of times a second.
                    }

                    isThrottled = true;

                    setTimeout(() => {
                        updateSplideNumberValue();
                        updateSplideNumberContent();

                        // Detect if there is a video element in the carousel container
                        let videoElements = parentCarouselPattern.getElementsByTagName('video');
                        if (videoElements.length > 0) {
                            updateVideoAndButtonOnSlideChange();
                        }

                        isThrottled = false;
                    }, 100); //make sure the callback can only be run a max of this many ms back-to-back
                }
            }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);

        function updateSplideNumberValue() {
            splide_aria_number_data = parentCarouselPattern
                .querySelectorAll('.splide__slide.is-active')[0]
                .getAttribute('aria-label');
            splideNumberStringAlteration(splide_aria_number_data);
        }

        //Alter the string so "x of x" renders as "xx/xx" -- e.g. "02 of 06" as "02/06"
        function splideNumberStringAlteration(input) {
            const [current, total] = input.split(' of ').map((num) => num.padStart(2, '0'));
            const output = `${current}/${total}`;
            splide_aria_number_data = output;
        }

        //insert the data in the carousel_numbers_element
        function updateSplideNumberContent() {
            carousel_numbers_element.textContent = splide_aria_number_data;
        }

        //Add back event listeners on buttons when they are automatically removed by Splide on screen resize.
        //this is needed since Splide re-renders the buttons entirely (thus clearing any additions such as carousel_numbers_element or eventlisteners) upon crossing the various breakpoints in either direction. This makes sure to add it back.
        let resizeTimeout;
        function handleResize() {
            if (!parentCarouselPattern.getElementsByClassName('splide-numbers')[0]) {
                //if on window resize it detects .splide-numbers no longer exists, re-add it
                // Ensure the previous arrow exists before calling `after` during resize handling
                const prevArrow2 = parentCarouselPattern.getElementsByClassName('splide__arrow--prev')[0];
                if (prevArrow2) {
                    prevArrow2.after(carousel_numbers_element);

                    if (videoElements.length > 0) {
                        prevArrow2.after(carousel_pause_play_element);

                        PausePlayVideoOnButtonPressInitialize();
                    }
                } else {
                    console.warn('Previous arrow not found during resize handling. Unable to append elements.');
                }
            }
        }

        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(handleResize, 100); // Adjust debounce delay as needed
        });

        handleResize();

        updateSplideNumberContent();

        // Detect if there is a video element in the carousel container
        let videoElements = parentCarouselPattern.getElementsByTagName('video');
        if (videoElements.length > 0) {
            //add an identifiable class to videos ending with an index number that goes up by 1
            for (let j = 0; j < videoElements.length; j++) {
                videoElements[j].classList.add('carouselVideo_' + j);
            }

            function videoCurrentAutoPlay(videoIndex) {
                if (videoIndex === undefined) {
                    videoIndex = 0;
                }

                const html5Video = videoElements[videoIndex];

                pauseDisableAllVideos();

                //play the relevant one
                if (html5Video) {
                    html5Video.autoplay = true;
                    html5Video.muted = true; // Most browsers require muted for autoplay
                    html5Video.play();
                    html5Video.loop = true;
                    html5Video.controls = false;
                    html5Video.currentTime = 0;
                }
            }

            function pauseDisableAllVideos() {
                //pause all videos in the carousel, and make sure controls are not visible
                let videoElements = parentCarouselPattern.getElementsByTagName('video');
                for (let j = 0; j < videoElements.length; j++) {
                    videoElements[j].pause();
                    videoElements[j].controls = false;
                }
            }

            // The video pause/play button is only supposed to exist on slides with a video.
            function toggleVideoPausePlayButton(addBtn) {
                if (addBtn === true) {
                    // Ensure the previous arrow exists before calling `after` for video pause/play button
                    const prevArrow3 = parentCarouselPattern.getElementsByClassName('splide__arrow--prev')[0];
                    if (prevArrow3) {
                        prevArrow3.after(carousel_pause_play_element);
                        PausePlayVideoOnButtonPressInitialize();
                    } else {
                        console.warn('Previous arrow not found for video pause/play button. Unable to append element.');
                    }
                } else {
                    carousel_pause_play_element.remove();
                }
            }

            PausePlayVideoOnButtonPressInitialize = function () {
                let pausePlayButton = document.querySelector('.splide-pausePlayBtn');

                if (pausePlayButton && !pausePlayButton.dataset.listenerAttached) {
                    pausePlayButton.addEventListener('click', function (e) {
                        e.preventDefault();

                        //get the current video in the active slide
                        let currentSlide = parentCarouselPattern.querySelectorAll('.splide__slide.is-active')[0];
                        let activeVideo = currentSlide.getElementsByTagName('video');

                        //pause if it is playing, play if it is paused
                        if (activeVideo[0].paused) {
                            activeVideo[0].play();
                            carousel_pause_inner_span.textContent = 'pause';
                            carousel_pause_play_element.classList.add('pause');
                            carousel_pause_play_element.classList.remove('play');
                        } else {
                            activeVideo[0].pause();
                            carousel_pause_inner_span.textContent = 'play';
                            carousel_pause_play_element.classList.remove('pause');
                            carousel_pause_play_element.classList.add('play');
                        }
                    });

                    pausePlayButton.dataset.listenerAttached = 'true;'; // prevent duplicate binding
                }
            };

            updateVideoAndButtonOnSlideChange = function () {
                // detect if current slide has video or not
                let currentSlide = parentCarouselPattern.querySelectorAll('.splide__slide.is-active')[0];
                if (currentSlide.getElementsByTagName('video').length > 0) {
                    //reset the state of the pause/play button to default
                    carousel_pause_inner_span.textContent = 'pause';
                    carousel_pause_play_element.classList.add('pause');
                    carousel_pause_play_element.classList.remove('play');

                    toggleVideoPausePlayButton(true);

                    //get what video it is, by getting number value at the end of the classes added earlier
                    let videoIndexElement = currentSlide.querySelector("[class^='carouselVideo_']"); // eslint-disable-line
                    if (videoIndexElement) {
                        let videoIndex = videoIndexElement.className;
                        videoIndex = videoIndex[videoIndex.length - 1];

                        videoCurrentAutoPlay(videoIndex);
                    } else {
                        console.warn('Video index element not found in the current slide.');
                    };
                } else {
                    toggleVideoPausePlayButton(false);
                    pauseDisableAllVideos();
                }
            }

            //if starting slide is a video, autoplay
            let startingSlide = parentCarouselPattern.querySelectorAll('.splide__slide.is-active')[0];
            if (startingSlide.getElementsByTagName('video').length > 0) {
                videoCurrentAutoPlay(); //auto plays the video as minimally as possible;
                toggleVideoPausePlayButton(true);
            }
        }

        // Only for the "home hero" variant, only on mobile smaller than 768px, swap the top content section so that it is inside the carousel markup, visually in between the carousel content and the button. Swap back when above 768px.
        function heroCarouselContentPositionSwap() {
            if (
                document.querySelectorAll('.home-hero').length > 0 &&
                parentCarouselPattern.classList.contains('carousel-home')
            ) {
                const splideArrows = parentCarouselPattern.querySelectorAll('.splide__arrows')[0];
                const homeHero = document.querySelector('.home-hero');
                const heroCarouselContent = document.querySelector('.hero-content-container').outerHTML;

                if (window.innerWidth < 768) {
                    //if mobile
                    document.querySelectorAll('.hero-content-container').forEach((el) => el.remove()); //get rid of all existing instances of this content
                    splideArrows.insertAdjacentHTML('afterend', heroCarouselContent); //add content to the new place
                } else {
                    //if desktop
                    document.querySelectorAll('.hero-content-container').forEach((el) => el.remove());
                    homeHero.insertAdjacentHTML('afterbegin', heroCarouselContent);
                }
            }
        }
        if (document.querySelectorAll('.home-hero').length > 0) {
            // Debounce utility.
            function heroCarouselContentPositionSwap_debounce(func, delay) {
                let timeout;
                return function () {
                    clearTimeout(timeout);
                    timeout = setTimeout(func, delay);
                };
            }

            const heroCarouselContentPositionSwap_debouncedResize = heroCarouselContentPositionSwap_debounce(
                heroCarouselContentPositionSwap,
                15
            );

            // Trigger on load
            heroCarouselContentPositionSwap(); // Initial call

            // Trigger on resize with debounce
            window.addEventListener('resize', heroCarouselContentPositionSwap_debouncedResize);
        }
    }

    // Close all other .wp-block-details elements when one is opened, if there are any present on the page.
    document.querySelectorAll('.wp-block-details').forEach((details) => {
        details.addEventListener('click', function () {
            // Remove the 'open' attribute from all other details elements
            document.querySelectorAll('.wp-block-details').forEach((otherDetails) => {
                if (otherDetails !== this) {
                    otherDetails.removeAttribute('open');
                }
            });
        });
    });

    // Initialize all Bootstrap accordions on the page
    // document.querySelectorAll('.accordion').forEach((accordionEl) => {
    //     new bootstrap.Accordion(accordionEl);
    // });

    // Make accordion and item IDs unique for all accordions on the page
    function makeAccordionsDynamic() {
        document.querySelectorAll('.pacecore-accordion').forEach((accordion, accIdx) => {
            const accId = 'accordion_' + accIdx + '_' + Math.random().toString(36).substr(2, 5);
            accordion.id = accId;
            const items = accordion.querySelectorAll('.accordion-item');
            items.forEach((item, i) => {
                // Find header and collapse elements
                const header = item.querySelector('.accordion-header');
                const button = item.querySelector('.accordion-button');
                const collapse = item.querySelector('.accordion-collapse');
                if (!header || !button || !collapse) return;
                const headingId = accId + '_heading_' + i;
                const collapseId = accId + '_collapse_' + i;
                // Update IDs and attributes
                header.id = headingId;
                button.setAttribute('aria-controls', collapseId);
                button.setAttribute('data-bs-target', '#' + collapseId);
                collapse.id = collapseId;
                collapse.setAttribute('data-bs-parent', '#' + accId);
            });
        });
    }

    makeAccordionsDynamic();

    document.querySelectorAll('.accordion-button').forEach((button) => {
        button.addEventListener('click', function () {
            const accordionItem = button.closest('.accordion-item');
            if (accordionItem) {
                setTimeout(() => {
                    const rect = accordionItem.getBoundingClientRect();
                    const fullyVisible =
                        rect.top >= 0 &&
                        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
                    if (!fullyVisible) {
                        accordionItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 300); // delay to allow collapse animation
            }
        });
    });

    // Accessibility: Add aria-label to first <li> in each .footer-nav <ul> if not a link
    var footerRight = document.querySelector('.footer-right');
    if (!footerRight) return;
    var navs = footerRight.querySelectorAll('.footer-nav ul');
    navs.forEach(function (ul) {
        var firstLi = ul.querySelector('li');

        if (firstLi && !firstLi.querySelector('a')) {
            if (!firstLi.hasAttribute('aria-label')) {
                var text = firstLi.textContent.trim();
                if (text) {
                    firstLi.setAttribute('aria-label', text);
                    firstLi.setAttribute('tabindex', '0');
                }
            }
        }
    });

    document.querySelectorAll('.search-form-clear').forEach((clearBtn) => {
        const input = clearBtn.closest('form')?.querySelector('.search-form-input');
        function toggleDisabled() {
            clearBtn.disabled = !input || input.value === '';
        }
        if (input) {
            input.addEventListener('input', toggleDisabled);
            toggleDisabled();
        }
        clearBtn.addEventListener('click', function (e) {
            e.preventDefault();
            if (input) {
                input.value = '';
                toggleDisabled();
                input.focus();
            }
        });
    });

    // Remove aria-expanded attribute from all .accordion-button elements
    document.querySelectorAll('.accordion-button').forEach((button) => {
        button.removeAttribute('aria-expanded');
    });

});

//Image text list pattern, if there is an .upper-title-text element, make it render on top of the image instead of below on mobile.
//and to swap back and forth when going between the breakpoint of 781px
function swapTopTitlePositionOnPatternImageTextList() {
    const pattern_image_text_lists = document.querySelectorAll('.image-text-list');

    for (let i = 0; i < pattern_image_text_lists.length; i++) {
        const parentPattern = pattern_image_text_lists[i];

        let upper_title_to_move = parentPattern.querySelectorAll('.upper-title-text')[0];

        if (upper_title_to_move) {
            if (window.innerWidth < 782) {
                parentPattern.querySelectorAll('.wp-block-columns')[0].before(upper_title_to_move);
            } else {
                parentPattern.querySelectorAll('.wp-block-columns .wp-block-heading')[0].before(upper_title_to_move);
            }
        }
    }
}
if (document.querySelectorAll('.image-text-list .upper-title-text').length > 0) {
    // Debounce utility -- Copilot helped with this bit of functionality.
    function debounce(func, delay) {
        let timeout;
        return function () {
            clearTimeout(timeout);
            timeout = setTimeout(func, delay);
        };
    }

    const debouncedResize = debounce(swapTopTitlePositionOnPatternImageTextList, 25);

    // Trigger on load, but only on appropriately small sizes
    if (window.innerWidth < 782) {
        swapTopTitlePositionOnPatternImageTextList(); // Initial call, if pageload starts in a mobile size.
    }

    // Trigger on resize with debounce
    window.addEventListener('resize', debouncedResize);
}

const headerPrimaryInner = document.querySelector('.header-primary-inner');

// Toggle class on .header-nav-dropdown matching the rel attribute of clicked .wp-block-button__link inside .header-nav-trigger
document.querySelectorAll('.header-nav-trigger .wp-block-button__link[rel]').forEach((button) => {
    //some accessibility defaults
    button.setAttribute('aria-haspopup', 'true');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('tabindex', '0');
    button.setAttribute('role', 'button');

    function toggleMega(relId) {
        // Toggle aria-expanded
        if (button.getAttribute('aria-expanded') === 'true') {
            button.setAttribute('aria-expanded', 'false');
        } else {
            button.setAttribute('aria-expanded', 'true');
        }

        if (!relId) return;

        // Close search popups if any are open
        closeSearchPopups();

        // Loop through all dropdowns and toggle open class only on the one matching relId
        document.querySelectorAll('.header-nav-dropdown').forEach((dropdown) => {
            if (dropdown.id === relId) {
                // Toggle the open class and set active class on the trigger accordingly
                const isOpen = dropdown.classList.toggle('header-nav-dropdown-open');
                if (isOpen) {
                    button.classList.add('header-nav-trigger-active');
                    headerPrimaryInner.classList.add('border-active');
                } else {
                    button.classList.remove('header-nav-trigger-active');
                    headerPrimaryInner.classList.remove('border-active');
                }
            } else {
                // Close all other dropdowns
                dropdown.classList.remove('header-nav-dropdown-open');
            }
        });
        // Remove active class from all other triggers except the clicked one
        document.querySelectorAll('.header-nav-trigger .wp-block-button__link[rel]').forEach((otherBtn) => {
            if (otherBtn !== button) {
                otherBtn.classList.remove('header-nav-trigger-active');
            }
        });
    }

    // Add click event listener to each button with a rel attribute
    button.addEventListener('click', function (e) {
        e.preventDefault();
        const relId = this.getAttribute('rel');
        toggleMega(relId);
    });
    button.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            const relId = this.getAttribute('rel');
            toggleMega(relId);
        }
    });
});

// Change the id of the search form label and input for mobile to avoid duplicate id's
if (headerPrimaryInner.querySelectorAll('.header-search-form-label')[0]) {
    headerPrimaryInner.querySelectorAll('.header-search-form-label')[0].setAttribute('for', 'website-search-mobile');
}
if (headerPrimaryInner.querySelectorAll('.header-search-form-input')[0]) {
    headerPrimaryInner.querySelectorAll('.header-search-form-input')[0].setAttribute('id', 'website-search-mobile');
}

// Toggle search bar open/close when .header-search-trigger is clicked, or the x button within the mobile search.

//if parent is .header-search-trigger-mobile or .header-search-trigger-desktop, add a class next to .header-search-trigger (which is a child of either of those in the markup) noting which it is, to directly differentiate the two buttons.
if (headerPrimaryInner.querySelectorAll('.header-search-trigger-mobile .header-search-trigger')) {
    headerPrimaryInner
        .querySelector('.header-search-trigger-mobile .header-search-trigger')
        .classList.add('header-search-trigger-mobile-inner');
}
if (headerPrimaryInner.querySelectorAll('.header-search-trigger-desktop .header-search-trigger')) {
    headerPrimaryInner
        .querySelector('.header-search-trigger-desktop .header-search-trigger')
        .classList.add('header-search-trigger-desktop-inner');
}

document.querySelectorAll('.header-search-trigger').forEach((trigger) => {
    // Search popup accessibility defaults
    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-expanded', 'false');

    toggleHeaderSearch(trigger);
});
// When click the x button inside the mobile search popup
document.querySelector('.search-x').addEventListener('click', function (e) {
    e.preventDefault();
    const trigger_mobile = document.querySelector('.header-search-trigger-mobile-inner');
    const parent = trigger_mobile.parentElement;
    if (parent.classList.contains('header-search-open')) {
        parent.classList.remove('header-search-open');
    }
    trigger_mobile.setAttribute('aria-expanded', 'false');
    const searchForm = parent.querySelector('.header-search-form');
    if (searchForm) {
        searchForm.setAttribute('aria-hidden', 'true');
    }
    trigger_mobile.focus();
});

function toggleHeaderSearch(trigger) {
    trigger.addEventListener('click', function (e) {
        e.preventDefault();

        // Toggle aria-expanded
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (expanded) {
            headerPrimaryInner.classList.remove('border-active');
        } else {
            headerPrimaryInner.classList.add('border-active');
        }

        // Toggle open class and aria-hidden on .header-search-form
        if (trigger.classList.contains('header-search-trigger-mobile-inner')) {
            const parent = trigger.parentElement;
            parent.classList.toggle('header-search-open');
            const searchForm = parent.querySelector('.header-search-form');
            if (searchForm) {
                searchForm.setAttribute('aria-hidden', expanded ? 'true' : 'false');
                if (!expanded) {
                    const input = searchForm.querySelector('.header-search-form-input');
                    if (input) input.focus();
                }
            }
        }
        if (trigger.classList.contains('header-search-trigger-desktop-inner')) {
            const parent = trigger.parentElement;
            parent.classList.toggle('header-search-open');
            const searchForm = parent.querySelector('.header-search-form');
            if (searchForm) {
                searchForm.setAttribute('aria-hidden', expanded ? 'true' : 'false');
                if (!expanded) {
                    const input = searchForm.querySelector('.header-search-form-input');
                    if (input) input.focus();
                }
            }
        }

        // Close all megamenus if any are open.
        closeAllMegaMenus();
    });
}

// Close all megamenus or search popups on escape press or on clicking outside of the primary menu area
headerPrimaryInner.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
        // Detect escapes if focused inside headerPrimaryInner or children of it
        closeAllMegaMenus();
        closeSearchPopups();
        headerPrimaryInner.classList.remove('border-active');
    }
});

function handleClickOutside(e) {
    if (
        !headerPrimaryInner.contains(e.target) &&
        (headerPrimaryInner.querySelector('.header-nav-trigger-active') ||
            headerPrimaryInner.querySelector('.header-search-open'))
    ) {
        closeAllMegaMenus();
        closeSearchPopups();
        headerPrimaryInner.classList.remove('border-active');
    }
}
document.addEventListener('click', handleClickOutside);

// Toggle mobile navigation open/close when .header-primary-trigger-mobile is clicked
const header_hamburger = document.querySelectorAll('.header-hamburger')[0];
const header_x = document.querySelectorAll('.header-x')[0];
document.querySelectorAll('.header-primary-trigger-mobile').forEach((trigger) => {
    trigger.addEventListener('click', function (e) {
        e.preventDefault();
        // Toggle class on body and on the trigger itself
        document.body.classList.toggle('header-primary-mobile-open');
        trigger.classList.toggle('header-primary-trigger-mobile-active');

        //toggle hamburger and x icons
        header_hamburger.classList.toggle('active');
        header_x.classList.toggle('active');

        //close search popups if any are open
        closeSearchPopups();
    });
});

// Detect when screen goes above 991px, and if the mobile menu is open, reset it to default closed values.
function resetMobileMenuOnThreshold() {
    if (window.innerWidth > 991 && document.querySelectorAll('.header-primary-trigger-mobile-active').length > 0) {
        document.querySelectorAll('.header-primary-mobile-active').forEach((el) => {
            el.classList.remove('header-primary-mobile-active');
        });
        document.querySelectorAll('.header-primary-mobile-open').forEach((el) => {
            el.classList.remove('header-primary-mobile-open');
        });
        document.querySelectorAll('.header-primary-trigger-mobile-active').forEach((el) => {
            el.classList.remove('header-primary-trigger-mobile-active');
        });

        header_hamburger.classList.add('active');
        header_x.classList.remove('active');
    }
}
// Debounce utility
function mobileMenuDebounce(func, delay) {
    let timeout;
    return function () {
        clearTimeout(timeout);
        timeout = setTimeout(func, delay);
    };
}

const debouncedResize = mobileMenuDebounce(resetMobileMenuOnThreshold, 10);

// Trigger on resize with debounce
window.addEventListener('resize', debouncedResize);

//functions to remove MegaMenus or Search Popups
function closeAllMegaMenus() {
    if (headerPrimaryInner.querySelector('.header-nav-trigger-active')) {
        headerPrimaryInner.querySelectorAll('.header-nav-trigger-active').forEach((navTriggers) => {
            navTriggers.classList.remove('header-nav-trigger-active');
            navTriggers.setAttribute('aria-expanded', 'false');
        });
    }

    if (headerPrimaryInner.querySelector('.header-nav-dropdown-open')) {
        headerPrimaryInner.querySelectorAll('.header-nav-dropdown-open').forEach((navDropdowns) => {
            navDropdowns.classList.remove('header-nav-dropdown-open');
        });
    }
}
function closeSearchPopups() {
    if (headerPrimaryInner.querySelector('.header-search-open')) {
        headerPrimaryInner.querySelectorAll('.header-search').forEach((searchForm) => {
            searchForm.classList.remove('header-search-open');
            searchForm.querySelector('.header-search-trigger').setAttribute('aria-expanded', 'false');
            searchForm.querySelector('.header-search-trigger').classList.remove('border-active');
        });
    }
}

//Text/Image Pattern element, swap content on breakpoint.
//If there are buttons, swap those to the other column all the time.
//If there are images, and the image(s) are on the left, make sure text content stacks on top on mobile.
//And swap these back and forth when going between the breakpoint
function TextImagePattern_SwapContentOnBreakpoint() {
    const pattern_text_image = document.querySelectorAll('.text-image');

    for (let i = 0; i < pattern_text_image.length; i++) {
        const parentPattern = pattern_text_image[i];

        // functionality to move the buttons group
        let buttons_to_move = parentPattern.querySelectorAll('.text-image-buttons')[0];
        if (buttons_to_move) {
            if (window.innerWidth < 782) {
                parentPattern.querySelectorAll('.text-image-images')[0].appendChild(buttons_to_move);
            } else {
                parentPattern.querySelectorAll('.text-image-content')[0].appendChild(buttons_to_move);
            }
        }

        //functionality to move the content on top on mobile if the container has the special class specifying it is an image-left variant of the component
        if (parentPattern.classList.contains('image-left')) {
            const parentColumns = parentPattern.querySelectorAll('.wp-block-columns')[0];
            const content = parentColumns.querySelector('.text-image-content');
            const media = parentColumns.querySelector('.text-image-images');

            if (window.innerWidth < 782) {
                //mobile is always content first (top), media second (bottom)
                parentColumns.insertBefore(content, media);
            } else {
                parentColumns.insertBefore(media, content);
            }
        }
    }
}
if (
    document.querySelectorAll('.text-image .text-image-buttons').length > 0 ||
    document.querySelectorAll('.text-image')
) {
    // Debounce utility.
    function TextImagePattern_debounce(func, delay) {
        let timeout;
        return function () {
            clearTimeout(timeout);
            timeout = setTimeout(func, delay);
        };
    }

    const TextImagePattern_debouncedResize = TextImagePattern_debounce(TextImagePattern_SwapContentOnBreakpoint, 15);

    // Trigger on load
    TextImagePattern_SwapContentOnBreakpoint(); // Initial call

    // Trigger on resize with debounce
    window.addEventListener('resize', TextImagePattern_debouncedResize);
}

//Video embed functionality, to replace cover image with video embed container on button click
document.querySelectorAll('.video-embed').forEach((videoEmbed) => {
    let videoPlayButton = videoEmbed.querySelector('.video-embed-preview');

    videoEmbed.querySelector('iframe').setAttribute('aria-hidden', 'true'); // add aria-hidden true and tabindex -1 on all iframes hidden behind an embed cover
    videoEmbed.querySelector('iframe').setAttribute('tabindex', '-1');

    videoPlayButton.addEventListener('click', function (e) {
        e.preventDefault();

        videoEmbed.classList.add('video-embed-playing');

        // Add autoplay for YouTube, Vimeo, or HTML5 video
        const iframe = videoEmbed.querySelector('iframe');
        const html5Video = videoEmbed.querySelector('video');

        iframe.setAttribute('aria-hidden', 'false'); // remmove aria-hidden true, and add tabindex 0, on specific iframe hidden behind embed cover that was just clicked
        iframe.setAttribute('tabindex', '0');
        videoEmbed.querySelector('.is-type-video').setAttribute('tabindex', '0');

        setTimeout(() => {
            iframe.focus(); // force focus to the iframe
            videoEmbed.querySelector('.wp-block-button__link').style.display = 'none'; //Display none the button so screen readers ignore this play button at this point
        }, 200);

        if (iframe) {
            if (iframe.src.includes('youtube.com')) {
                // YouTube autoplay
                let src = iframe.src;
                if (src.indexOf('autoplay=1') === -1) {
                    src += src.indexOf('?') === -1 ? '?autoplay=1' : '&autoplay=1';
                    iframe.src = src;
                }
            } else if (iframe.src.includes('vimeo.com')) {
                // Vimeo autoplay
                let src = iframe.src;
                if (src.indexOf('autoplay=1') === -1) {
                    src += src.indexOf('?') === -1 ? '?autoplay=1' : '&autoplay=1';
                    iframe.src = src;
                }
            }
        } else if (html5Video) {
            // HTML5 video autoplay
            html5Video.autoplay = true;
            html5Video.muted = true; // Most browsers require muted for autoplay
            html5Video.play();
        }
    });
});

const sliders = document.querySelectorAll('.before-after-slider');

sliders.forEach((slider) => {
    const firstImage = slider.querySelector('.wp-block-image:first-child');
    const lastImage = slider.querySelector('.wp-block-image:last-child');

    // Dynamically add the slider-handle if it doesn't exist
    let handle = slider.querySelector('.slider-handle');
    if (!handle) {
        handle = document.createElement('div');
        handle.className = 'slider-handle';
        slider.appendChild(handle);
    }

    let isDragging = false;

    // Function to update clip-path based on handle position
    const updateSlider = (event) => {
        const sliderRect = slider.getBoundingClientRect();
        const offsetX = event.clientX - sliderRect.left;

        // Ensure the handle stays within bounds
        const percentage = Math.max(0, Math.min(100, (offsetX / sliderRect.width) * 100));

        // Update clip-paths and handle position
        firstImage.style.clipPath = `inset(0 ${100 - percentage}% 0 0)`;
        lastImage.style.clipPath = `inset(0 0 0 ${percentage}%)`;
        handle.style.left = `${percentage}%`;
    };

    // Mouse down event to start dragging
    handle.addEventListener('mousedown', (event) => {
        isDragging = true;
        slider.classList.add('dragging');
        updateSlider(event);
    });

    // Mouse move event to update slider while dragging
    document.addEventListener('mousemove', (event) => {
        if (isDragging) {
            updateSlider(event);
        }
    });

    // Mouse up event to stop dragging
    document.addEventListener('mouseup', () => {
        if (isDragging) {
            isDragging = false;
            slider.classList.remove('dragging');
        }
    });

    // Touch events for mobile support
    handle.addEventListener('touchstart', (event) => {
        isDragging = true;
        slider.classList.add('dragging');
        updateSlider(event.touches[0]);
    });

    document.addEventListener('touchmove', (event) => {
        if (isDragging) {
            updateSlider(event.touches[0]);
        }
    });

    document.addEventListener('touchend', () => {
        if (isDragging) {
            isDragging = false;
            slider.classList.remove('dragging');
        }
    });
});

function faq_cta_swapRightContentOnBreakpoint() {
    //functionality to move the content on top on mobile if the container has the special class specifying it is a content-right variant of the component
    const faq_cta = document.querySelectorAll('.faq-cta');

    for (let i = 0; i < faq_cta.length; i++) {
        const parentPattern = faq_cta[i];

        if (parentPattern.classList.contains('right-content')) {
            const parentColumns = parentPattern.querySelectorAll('.wp-block-columns')[0];
            const content = parentColumns.querySelector('.faq-cta-column');
            const accordion = parentColumns.querySelector('.accordion-column');

            if (window.innerWidth < 782) {
                //mobile is always content first (top), media second (bottom)
                parentColumns.insertBefore(content, accordion);
            } else {
                parentColumns.insertBefore(accordion, content);
            }
        }
    }
}
if (document.querySelectorAll('.faq-cta.right-content').length > 0) {
    // Debounce utility.
    function FaqCtaPattern_debounce(func, delay) {
        let timeout;
        return function () {
            clearTimeout(timeout);
            timeout = setTimeout(func, delay);
        };
    }

    const FaqCtaPattern_debouncedResize = FaqCtaPattern_debounce(faq_cta_swapRightContentOnBreakpoint, 15);

    // Trigger on load
    faq_cta_swapRightContentOnBreakpoint(); // Initial call

    // Trigger on resize with debounce
    window.addEventListener('resize', FaqCtaPattern_debouncedResize);
}
